import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SignaturePad } from 'angular2-signaturepad/signature-pad';
import { SysUsersService } from '../../../services/sys-users.service';
const Lockr = require("lockr");

@Component({
  selector: 'ngx-complete-register',
  templateUrl: './complete-register.component.html',
  styleUrls: ['./complete-register.component.scss'],
})
export class CompleteRegisterComponent implements OnInit {
  @ViewChild(SignaturePad, { static: true }) signaturePad: SignaturePad;
  @Input() accountId: any = false;
  @Input() isSuperAdmin: boolean;
  @Output() showPanel: EventEmitter<any> = new EventEmitter();
  loading = false;
  signaturePadOptions: Object;

  constructor(
    private userService: SysUsersService,
  ) { }

  ngOnInit() {
    const width = document.documentElement.clientWidth * .36;
    this.signaturePadOptions = {
      maxWidth: 1,
      'minWidth': 0.8,
      'backgroundColor': 'RGBA(245, 247, 249, 1.00)',
      'canvasWidth': width,
    };
  }

  clearSignature() {
    this.signaturePad.clear();
  }

  async completeRegister() {
    this.loading = true;
    const signature = this.signaturePad.toDataURL();
    const [error] = await this.userService.uploadSignature(this.accountId, signature, this.isSuperAdmin);
    this.loading = false;
    if (error) return this.showPanel.emit(false);

    Lockr.rm('initialData');
    window.location.reload();
    this.showPanel.emit(true);
  }
}
